export const GET_COPO_BASIC_INFO = "GET_COPO_BASIC_INFO";
export const GET_COPO_BASIC_INFO_SUCCESS = "GET_COPO_BASIC_INFO_SUCCESS";
export const GET_COPO_BASIC_INFO_FAILURE = "GET_COPO_BASIC_INFO_FAILURE";

export const SET_COPO_BASIC_INFO_FORM_DATA = "SET_COPO_BASIC_INFO_FORM_DATA";
export const SET_COPO_GENERAL_DETAILS_DATA = "SET_COPO_GENERAL_DETAILS_DATA";
export const RESET_COPO_DATA = "RESET_COPO_DATA";
